module.exports = __webpack_public_path__ + "img/ar.179e5cd6.png";